module.exports = __webpack_public_path__ + "img/reposicion_representacion.56c99389.png";